class CartRemoveButton extends HTMLElement {
  constructor() {
    super();
    this.addEventListener('click', (event) => {
      event.preventDefault();
      const cartItems = this.closest('cart-items') || this.closest('cart-drawer-items');
      cartItems.updateQuantity(this.dataset.index, 0);
    });
  }
}

customElements.define('cart-remove-button', CartRemoveButton);

class CartItems extends HTMLElement {
  constructor() {
    super();

    this.lineItemStatusElement = document.getElementById('shopping-cart-line-item-status') || document.getElementById('CartDrawer-LineItemStatus');

    this.currentItemCount = Array.from(this.querySelectorAll('[name="updates[]"]'))
      .reduce((total, quantityInput) => total + parseInt(quantityInput.value), 0);

    this.debouncedOnChange = debounce((event) => {
      this.onChange(event);
    }, 300);

    this.addEventListener('change', this.debouncedOnChange.bind(this));
  }

  onChange(event) {
    this.updateQuantity(event.target.dataset.index, event.target.value, document.activeElement.getAttribute('name'));
  }

  getSectionsToRender() {
    return [
      {
        id: 'main-cart-items',
        section: document.getElementById('main-cart-items')?.dataset.id,
        selector: '.js-contents',
      },
      {
        id: 'cart-icon-bubble',
        section: 'cart-icon-bubble',
        selector: '.shopify-section'
      },
      {
        id: 'cart-icon-bubble--mobile',
        section: 'cart-icon-bubble--mobile',
        selector: '.shopify-section'
      },
      {
        id: 'cart-live-region-text',
        section: 'cart-live-region-text',
        selector: '.shopify-section'
      },
      {
        id: 'main-cart-footer',
        section: document.getElementById('main-cart-footer')?.dataset.id,
        selector: '.js-contents',
      }
    ].filter(section => document.getElementById(section.id)); // Filter out null sections
  }

  updateQuantity(line, quantity, name) {
    this.enableLoading(line);

    const body = JSON.stringify({
      line,
      quantity,
      sections: this.getSectionsToRender().map((section) => section.section),
      sections_url: window.location.pathname,
    });

    fetch(`${routes.cart_change_url}`, { ...fetchConfig(), ...{ body } })
      .then((response) => {
        return response.text();
      })
      .then((state) => {
        const parsedState = JSON.parse(state);
        const quantityElement = document.getElementById(`Quantity-${line}`) || document.getElementById(`Drawer-quantity-${line}`);
        this.classList.toggle('is-empty', parsedState.item_count === 0);
        const cartDrawerWrapper = document.querySelector('cart-drawer');
        const cartFooter = document.getElementById('main-cart-footer');

        if (cartFooter) cartFooter.classList.toggle('is-empty', parsedState.item_count === 0);
        if (cartDrawerWrapper) cartDrawerWrapper.classList.toggle('is-empty', parsedState.item_count === 0);

        this.getSectionsToRender().forEach((section => {
          const elementToReplace = document.getElementById(section.id).querySelector(section.selector) || document.getElementById(section.id);
          if (!parsedState.errors && parsedState.sections && parsedState.sections[section.section]) {
            elementToReplace.innerHTML = this.getSectionInnerHTML(parsedState.sections[section.section], section.selector);
          }
        }));

        if (parsedState.errors) {
          quantityElement.value = quantityElement.getAttribute('value');
          this.updateLiveRegions(line, parsedState.errors);
          this.querySelectorAll('.loading-overlay').forEach((overlay) => overlay.classList.add('hidden'));
          return;
        }
        
        const lineItem = document.getElementById(`CartItem-${line}`) || document.getElementById(`CartDrawer-Item-${line}`);
        if (lineItem && lineItem.querySelector(`[name="${name}"]`)) {
          cartDrawerWrapper ? trapFocus(cartDrawerWrapper, lineItem.querySelector(`[name="${name}"]`)) : lineItem.querySelector(`[name="${name}"]`).focus();
        } else if (parsedState.item_count === 0 && cartDrawerWrapper) {
          trapFocus(cartDrawerWrapper.querySelector('.drawer__inner-empty'), cartDrawerWrapper.querySelector('a'))
        } else if (document.querySelector('.cart-item') && cartDrawerWrapper) {
          trapFocus(cartDrawerWrapper, document.querySelector('.cart-item__name'))
        }
        this.disableLoading();

        // Update cart count in header
        updateCartCount();
        
        var freedelivery = parsedState.sections ? parsedState.sections[Object.keys(parsedState.sections)[0]] : '';
        if(document.getElementById('cart-page-free-delivery')){
          freedelivery = freedelivery.split('<div id="cart-page-free-delivery" class="free-delivery-bar">').pop();
          freedelivery = freedelivery.split('<div class="free-delivery-bar__end hide"></div>').shift();
          if(document.getElementById('cart-page-free-delivery')) document.getElementById('cart-page-free-delivery').innerHTML = freedelivery;
          if(document.getElementById('product-page-free-delivery')) document.getElementById('product-page-free-delivery').innerHTML = freedelivery;
        }
      }).catch(() => {
        this.querySelectorAll('.loading-overlay').forEach((overlay) => overlay.classList.add('hidden'));
        const errors = document.getElementById('cart-errors') || document.getElementById('CartDrawer-CartErrors');
        errors.textContent = window.cartStrings.error;
        this.disableLoading();
      });
  }

  updateLiveRegions(line, message) {
    const lineItemError = document.getElementById(`Line-item-error-${line}`) || document.getElementById(`CartDrawer-LineItemError-${line}`);
    if (lineItemError) lineItemError.querySelector('.cart-item__error-text').innerHTML = message;

    if (this.lineItemStatusElement) {
      this.lineItemStatusElement.setAttribute('aria-hidden', true);
    }

    const cartStatus = document.getElementById('cart-live-region-text') || document.getElementById('CartDrawer-LiveRegionText');
    if (cartStatus) {
      cartStatus.setAttribute('aria-hidden', false);

      setTimeout(() => {
        cartStatus.setAttribute('aria-hidden', true);
      }, 1000);
    }
  }
  
  getSectionInnerHTML(html, selector) {
    const parsed = new DOMParser()
      .parseFromString(html, 'text/html')
      .querySelector(selector);
    return parsed ? parsed.innerHTML : '';
  }

  enableLoading(line) {
    const mainCartItems = document.getElementById('main-cart-items') || document.getElementById('CartDrawer-CartItems');
    if (mainCartItems) {
      mainCartItems.classList.add('cart__items--disabled');
    }

    const cartItemElements = this.querySelectorAll(`#CartItem-${line} .loading-overlay`);
    const cartDrawerItemElements = this.querySelectorAll(`#CartDrawer-Item-${line} .loading-overlay`);

    [...cartItemElements, ...cartDrawerItemElements].forEach((overlay) => overlay.classList.remove('hidden'));

    if (document.activeElement) document.activeElement.blur();
    if (this.lineItemStatusElement) {
      this.lineItemStatusElement.setAttribute('aria-hidden', false);
    }
  }

  disableLoading() {
    const mainCartItems = document.getElementById('main-cart-items') || document.getElementById('CartDrawer-CartItems');
    if (mainCartItems) {
      mainCartItems.classList.remove('cart__items--disabled');
    }
  }
}

customElements.define('cart-items', CartItems);

if (!customElements.get('cart-note')) {
  customElements.define(
    'cart-note',
    class CartNote extends HTMLElement {
      constructor() {
        super();

        this.addEventListener(
          'input',
          debounce((event) => {
            const body = JSON.stringify({ note: event.target.value });
            fetch(`${routes.cart_update_url}`, { ...fetchConfig(), ...{ body } })
              .then(() => {
                // Cart update successful
                console.log('Cart note updated');
              })
              .catch(error => {
                console.error('Error updating cart note:', error);
              });
          }, 300) // Changed from ON_CHANGE_DEBOUNCE_TIMER to 300ms
        );
      }
    }
  );
}

// ====================
// ENHANCED ADD TO CART FUNCTIONALITY
// ====================

// Global cart functions
window.CartUtils = {
  // ADD TO CART FUNCTION
  addToCart: function(variantId, quantity = 1, productTitle = 'Product') {
    return new Promise((resolve, reject) => {
      console.log(`🛒 Adding to cart: Variant ${variantId}, Quantity ${quantity}`);
      
      fetch('/cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          items: [{
            id: variantId,
            quantity: quantity
          }]
        })
      })
      .then(response => response.json())
      .then(data => {
        console.log('✅ Cart response:', data);
        
        // Update cart count
        this.updateCartCount();
        
        // Show notification
        this.showNotification(`${productTitle} added to cart!`);
        
        // Refresh cart drawer if exists
        this.refreshCartDrawer();
        
        // Resolve promise
        resolve(data);
      })
      .catch(error => {
        console.error('❌ Cart error:', error);
        this.showNotification('Could not add to cart', 'error');
        reject(error);
      });
    });
  },
  
  // UPDATE CART COUNT
  updateCartCount: function() {
    // Try multiple selectors
    const selectors = [
      '.cart-count',
      '[data-cart-count]',
      '.cart-icon__count',
      '.js-cart-count',
      '.header__cart-count',
      '.cart-item-count'
    ];
    
    // First get current cart count from Shopify
    fetch('/cart.js')
      .then(response => response.json())
      .then(cart => {
        const count = cart.item_count || 0;
        
        // Update all cart count elements
        selectors.forEach(selector => {
          const elements = document.querySelectorAll(selector);
          elements.forEach(element => {
            element.textContent = count;
            if (element.hasAttribute('data-cart-count')) {
              element.setAttribute('data-cart-count', count);
            }
          });
        });
        
        // Update cart icon bubble
        const cartBubble = document.querySelector('.cart-count-bubble');
        if (cartBubble) {
          cartBubble.textContent = count;
          cartBubble.style.display = count > 0 ? 'flex' : 'none';
        }
        
        console.log(`🛒 Cart count updated to: ${count}`);
      })
      .catch(error => {
        console.error('Error fetching cart count:', error);
      });
  },
  
  // SHOW NOTIFICATION
  showNotification: function(message, type = 'success') {
    // Remove existing notifications
    document.querySelectorAll('.cart-notification').forEach(n => n.remove());
    
    const notification = document.createElement('div');
    notification.className = 'cart-notification';
    notification.style.cssText = `
      position: fixed;
      top: 20px;
      right: 20px;
      background: ${type === 'success' ? '#142C73' : '#ff4000'};
      color: white;
      padding: 15px 25px;
      border-radius: 8px;
      box-shadow: 0 4px 15px rgba(0,0,0,0.2);
      z-index: 99999;
      animation: slideIn 0.3s ease;
      display: flex;
      align-items: center;
      gap: 10px;
      font-weight: 600;
      font-size: 14px;
    `;
    
    notification.innerHTML = `
      <svg width="20" height="20" viewBox="0 0 20 20" fill="${type === 'success' ? '#4CAF50' : '#FFD700'}">
        ${type === 'success' ? 
          '<path d="M16.667 5L7.5 14.167 3.333 10"/>' :
          '<path d="M10 1.667L12.575 6.883L18.333 7.725L14.167 11.783L15.15 17.517L10 14.808L4.85 17.517L5.833 11.783L1.667 7.725L7.425 6.883L10 1.667Z"/>'}
      </svg>
      <span>${message}</span>
    `;
    
    document.body.appendChild(notification);
    
    // Add animation styles if not present
    if (!document.querySelector('#cart-animations')) {
      const style = document.createElement('style');
      style.id = 'cart-animations';
      style.textContent = `
        @keyframes slideIn {
          from { transform: translateX(100%); opacity: 0; }
          to { transform: translateX(0); opacity: 1; }
        }
        @keyframes slideOut {
          from { transform: translateX(0); opacity: 1; }
          to { transform: translateX(100%); opacity: 0; }
        }
      `;
      document.head.appendChild(style);
    }
    
    // Remove after 3 seconds
    setTimeout(() => {
      notification.style.animation = 'slideOut 0.3s ease';
      setTimeout(() => notification.remove(), 300);
    }, 3000);
  },
  
  // REFRESH CART DRAWER
  refreshCartDrawer: function() {
    const cartDrawer = document.querySelector('cart-drawer');
    if (cartDrawer) {
      // Trigger cart drawer refresh
      cartDrawer.getCart && cartDrawer.getCart();
    }
  },
  
  // HANDLE ALL ADD TO CART BUTTONS
  initAddToCartListeners: function() {
    document.addEventListener('click', function(e) {
      // Handle form submit buttons
      const addToCartBtn = e.target.closest('[type="submit"][name="add"], .add-to-cart, .product-form__submit, [data-add-to-cart]');
      
      if (addToCartBtn && addToCartBtn.type === 'submit') {
        const form = addToCartBtn.closest('form[action="/cart/add"]');
        if (form) {
          e.preventDefault();
          e.stopPropagation();
          
          // Get form data
          const variantInput = form.querySelector('input[name="id"]');
          const quantityInput = form.querySelector('input[name="quantity"]');
          const productTitle = form.closest('.product')?.querySelector('.product-title, .product__title, h1')?.textContent || 'Product';
          
          if (variantInput && variantInput.value) {
            const variantId = variantInput.value;
            const quantity = quantityInput ? parseInt(quantityInput.value) || 1 : 1;
            
            // Show loading state
            const originalText = addToCartBtn.innerHTML;
            addToCartBtn.innerHTML = 'Adding...';
            addToCartBtn.disabled = true;
            
            // Add to cart
            window.CartUtils.addToCart(variantId, quantity, productTitle)
              .then(() => {
                // Reset button
                addToCartBtn.innerHTML = originalText;
                addToCartBtn.disabled = false;
              })
              .catch(() => {
                // Reset button on error
                addToCartBtn.innerHTML = originalText;
                addToCartBtn.disabled = false;
              });
          }
        }
      }
      
      // Handle simple buttons with data attributes
      const simpleAddBtn = e.target.closest('[data-variant-id]:not([type])');
      if (simpleAddBtn) {
        e.preventDefault();
        const variantId = simpleAddBtn.getAttribute('data-variant-id');
        const quantity = simpleAddBtn.getAttribute('data-quantity') || 1;
        const productTitle = simpleAddBtn.getAttribute('data-product-title') || 'Product';
        
        if (variantId) {
          // Show loading state
          const originalText = simpleAddBtn.innerHTML;
          simpleAddBtn.innerHTML = 'Adding...';
          simpleAddBtn.disabled = true;
          
          window.CartUtils.addToCart(variantId, parseInt(quantity), productTitle)
            .then(() => {
              simpleAddBtn.innerHTML = originalText;
              simpleAddBtn.disabled = false;
            })
            .catch(() => {
              simpleAddBtn.innerHTML = originalText;
              simpleAddBtn.disabled = false;
            });
        }
      }
      
      // Handle quick view add to cart buttons
      const qvAddBtn = e.target.closest('#qvAddToCart');
      if (qvAddBtn && !qvAddBtn.disabled) {
        e.preventDefault();
        const variantSelect = document.getElementById('qvVariantSelect');
        const quantityInput = document.getElementById('qvQuantity');
        const productTitle = document.querySelector('.qv-product-title')?.textContent || 'Product';
        
        if (variantSelect && quantityInput) {
          const variantId = variantSelect.value || variantSelect.getAttribute('value');
          const quantity = parseInt(quantityInput.value) || 1;
          
          // Show loading in quick view
          const originalText = qvAddBtn.innerHTML;
          qvAddBtn.innerHTML = 'Adding...';
          qvAddBtn.disabled = true;
          
          window.CartUtils.addToCart(variantId, quantity, productTitle)
            .then(() => {
              qvAddBtn.innerHTML = originalText;
              qvAddBtn.disabled = false;
              
              // Close quick view after successful add
              setTimeout(() => {
                const modal = document.getElementById('quickViewModal');
                if (modal) {
                  modal.style.display = 'none';
                  document.body.style.overflow = 'auto';
                }
              }, 1500);
            })
            .catch(() => {
              qvAddBtn.innerHTML = originalText;
              qvAddBtn.disabled = false;
            });
        }
      }
    });
  },
  
  // INITIALIZE CART SYSTEM
  init: function() {
    this.initAddToCartListeners();
    
    // Set up quantity controls
    document.addEventListener('click', function(e) {
      // Quantity minus
      if (e.target.closest('.quantity-minus, .quantity__minus, .qv-quantity-btn:nth-child(1)')) {
        e.preventDefault();
        const container = e.target.closest('.quantity, .qv-quantity-controls');
        const input = container?.querySelector('input[type="number"]');
        if (input) {
          let value = parseInt(input.value);
          if (value > 1) {
            input.value = value - 1;
          }
        }
      }
      
      // Quantity plus
      if (e.target.closest('.quantity-plus, .quantity__plus, .qv-quantity-btn:nth-child(3)')) {
        e.preventDefault();
        const container = e.target.closest('.quantity, .qv-quantity-controls');
        const input = container?.querySelector('input[type="number"]');
        if (input) {
          let value = parseInt(input.value);
          input.value = value + 1;
        }
      }
    });
    
    console.log('🛒 Enhanced cart system initialized');
  }
};

// Initialize on page load
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', function() {
    window.CartUtils.init();
  });
} else {
  window.CartUtils.init();
}

// Make functions globally available
window.addToCart = window.CartUtils.addToCart;
window.updateCartCount = window.CartUtils.updateCartCount;
window.showCartNotification = window.CartUtils.showNotification;

// Debounce utility function (if not already defined)
if (typeof debounce === 'undefined') {
  function debounce(fn, wait) {
    let t;
    return function() {
      clearTimeout(t);
      t = setTimeout(() => fn.apply(this, arguments), wait);
    };
  }
}

// Fetch config utility (if not already defined)
if (typeof fetchConfig === 'undefined') {
  function fetchConfig() {
    return {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json'
      }
    };
  }
}

// Trap focus utility (if not already defined)
if (typeof trapFocus === 'undefined') {
  function trapFocus(element, elementToFocus = false) {
    const focusableElements = element.querySelectorAll('button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])');
    const firstFocusableElement = focusableElements[0];
    const lastFocusableElement = focusableElements[focusableElements.length - 1];

    function handleKeyDown(e) {
      if (e.key !== 'Tab') return;
      
      if (e.shiftKey) {
        if (document.activeElement === firstFocusableElement) {
          e.preventDefault();
          lastFocusableElement.focus();
        }
      } else {
        if (document.activeElement === lastFocusableElement) {
          e.preventDefault();
          firstFocusableElement.focus();
        }
      }
    }

    element.addEventListener('keydown', handleKeyDown);
    
    if (elementToFocus) {
      elementToFocus.focus();
    } else {
      firstFocusableElement.focus();
    }
    
    // Return cleanup function
    return () => element.removeEventListener('keydown', handleKeyDown);
  }
}